<template>
  <v-container class="d-flex justify-center fill-height">
    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: "Index",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
